import axios from 'axios'
import { Loading, Message } from 'element-ui'
import QS from 'qs'
import router from '../../router.js'

// axios.defaults.baseURL = "http://third.tuolele.cn/cms.php";
const baseurl = process.env.VUE_APP_BASE_URL
axios.defaults.baseURL = baseurl

axios.defaults.timeout = 30000
axios.defaults.withCredentials = true
axios.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded;charset=UTF-8'

let loading
let needLoadingRequestCount = 0
// 使用Element loading-start 方法
function startLoading() {
  loading = Loading.service({
    lock: true,
    text: '拼命加载中',
    background: 'rgba(255, 255, 255, 0)'
  })
}

// 使用Element loading-close 方法
function endLoading() {
  loading.close()
}

export function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading()
  }
  needLoadingRequestCount++
}

export function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) {
    return false
  }
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    endLoading()
  }
}

export { get, post }

// 封装get方法
function get(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, params)
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}

// 封装post方法
function post(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, QS.stringify(params))
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err && err.desc)
      })
  })
}

// 请求拦截(请求发出前处理请求)
axios.interceptors.request.use(
  confirm => {
    // 将token放入header，这里用Vuex把token放在store中，取出
    //    const token = store.state.token;
    //    token && (config.headers.Authorization = token);
    showFullScreenLoading()
    return confirm
  },
  error => {
    return Promise.error(error)
  }
)

// 响应拦截器（处理响应数据）
axios.interceptors.response.use(
  response => {
    if (response.status === 200) {
      if (response.data.code == 550) {
        Message.error({
          message: response.data.desc
        })
      }
      if (response.data.code == 401) {
        Message.error({
          message: response.data.desc
        })
        router.push('/login')
      }
      tryHideFullScreenLoading()
      return Promise.resolve(response)
    } else {
      return Promise.reject(response)
    }
  },
  error => {
    // //请求失败，这个地方可以根据error.response.status统一处理一些界面逻辑，比如status为401未登录,可以进行重定向
    // router.replace({
    //     path: "/login",
    //     query: { redirect: router.currentRoute.fullPath }
    //    });
    return Promise.reject(error.response)
  }
)
